import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs";

import { DocumentInfo } from "../models";
import { ConfigService } from "./config.service";
import { HeaderFactoryService } from './header-factory.service';
import { TokenService } from './token.service';

@Injectable()
export class DocumentsService {
  constructor(
    private httpsClient: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService,
    private headerService: HeaderFactoryService
  ) {}

  getDocuments(certificateNumber: string): Observable<DocumentInfo[]> {
    return this.httpsClient.get<DocumentInfo[]>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/documents/bycertificate/${certificateNumber}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  downloadDocument(
    certificateNumber: string,
    imageId: string
  ): Observable<any> {
    return this.httpsClient.get(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/documents/download/${certificateNumber}/${imageId}`,
      {
        responseType: "blob",
        headers: new HttpHeaders({
          Accept: "application/json",
          Authorization: `Bearer ${this.tokenService.getCurrentToken()}`
        })
      }
    );
  }

  cachePreneedReviewDocuments(
    stateOfIsssue: string,
    replacementYes: boolean,
    containsMultipleBeneficiaries: boolean,
  ): Observable<Response> {
    return this.httpsClient.get<Response>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/documents/preneed/cache/${stateOfIsssue}/${replacementYes}/${containsMultipleBeneficiaries}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }
}
